import FileSaver from 'file-saver';
import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';
import { userService } from '@saucelabs/sl-util-axios';

import { generateReportName } from './../activity/utils';


export const getGroups = ({ limit = PAGINATION_LIMIT, offset = 0, ...rest } = {}) => (
  userService.get('/v1/groups/', {
    params: {
      limit,
      offset,
      ...rest,
    },
  })
);

export const createGroup = ({ organizationId, ...params }) => {
  const data = {
    organization: organizationId,
    ...params,
  };
  return userService.post('/v1/groups/', data);
};

export const removeGroup = (id) => (
  userService.delete(`/v1/groups/${id}/`)
);

export const getOrganizationGroupsUsageCSV = ({ id, name }) => (
  userService.get(`/v1/organizations/${id}/groups-activity/`, {
    headers: {
      Accept: 'text/csv',
    },
    responseType: 'blob',
  }).then(({ data }) => {
    FileSaver.saveAs(data, generateReportName({
      rootSection: name,
      reportType: 'groups',
    }));
  })
);
